import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import useLocalStore from 'src/store/useLocalStore';
import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { I18NextNS } from 'src/models/Language.model';

type SitesDropdownProps = {
  handleSiteChange: (siteId: string | undefined) => void;
  toggleClassName?: string;
};

const SitesDropdown = ({
  handleSiteChange,
  toggleClassName,
}: SitesDropdownProps) => {
  const { t } = useTranslation(I18NextNS.COMMON);
  const { selectedSiteId, setSelectedSiteId, clearSelectedSiteId } =
    useLocalStore();
  const { sites } = useRemoteBoundStore();

  const allSitesLabel = t('sites.allSites');
  const selectedSiteName = sites.find(
    (site) => site.siteId === selectedSiteId,
  )?.siteName;

  return (
    <Dropdown id="sites-dropdown">
      <Dropdown.Toggle
        variant="outline-primary"
        size="sm"
        className={toggleClassName}
        id="sites-dropdown-toggle"
        data-test="site-filter-toggle"
      >
        {selectedSiteName ?? allSitesLabel}
      </Dropdown.Toggle>

      <Dropdown.Menu className="overflow-auto" style={{ maxHeight: '48vh' }}>
        <Dropdown.Item
          as="button"
          onClick={(e) => {
            e.preventDefault();
            clearSelectedSiteId();
            handleSiteChange(undefined);
          }}
        >
          {allSitesLabel}
        </Dropdown.Item>
        {sites.map((site) => (
          <Dropdown.Item
            key={site.siteId}
            data-test="site-filter-option"
            as="button"
            onClick={(e) => {
              e.preventDefault();
              setSelectedSiteId(site.siteId);
              handleSiteChange(site.siteId);
            }}
          >
            {site.siteName}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SitesDropdown;
